import React from 'react';
import { Empty, Skeleton } from 'antd';

interface FeedbackStateProps {
  loading?: boolean;
  isEmpty?: boolean;
  emptyDescription?: string;
}

/** Inline loading / empty states only — use `toast` from `lib/toast` for success and errors. */
const FeedbackState: React.FC<FeedbackStateProps> = ({
  loading = false,
  isEmpty = false,
  emptyDescription = 'No data available.',
}) => {
  if (loading) {
    return <Skeleton active paragraph={{ rows: 6 }} />;
  }

  if (isEmpty) {
    return <Empty description={emptyDescription} />;
  }

  return null;
};

export default FeedbackState;
